const rawBaseUrl =
  process.env.REACT_APP_BACKEND_URL ||
  process.env.REACT_APP_API_URL ||
  process.env.VITE_API_URL ||
  '';

const normalizedBaseUrl = rawBaseUrl.replace(/\/+$/, '');

export const API_BASE_URL = normalizedBaseUrl.endsWith('/api')
  ? normalizedBaseUrl.slice(0, -4)
  : normalizedBaseUrl;

export const API = API_BASE_URL ? `${API_BASE_URL}/api` : '/api';
